import { getUTCTimestamp } from './utils';

const fetchSync = require('sync-fetch')

let fetcherCache = {}; // dict of {data:..., time:...}

export function fetcherGetSync(url, minCacheGap=10*1000) {
    if(Object.keys(fetcherCache).includes(url) && (getUTCTimestamp() - fetcherCache[url].time) < minCacheGap){
        return fetcherCache[url].data;
    }
    else {
        let res = fetchSync(url, {
            method: "GET", //ou POST, PUT, DELETE, etc.
            headers: {
                "Authorization": "Bearer "+localStorage.getItem('token')
            }
          }).json()
        
        fetcherCache[url] = {
            data: res,
            time: getUTCTimestamp()
        };
        return res;
    }
}

export function fetcherSync(url, method="GET", body={}, minCacheGap=10*1000) {
    if(method.localeCompare("GET") === 0 && Object.keys(fetcherCache).includes(url) && (getUTCTimestamp() - fetcherCache[url].time) < minCacheGap){
        return fetcherCache[url].data;
    }
    else {
        let res = fetchSync(url, {
            method: method, //ou POST, PUT, DELETE, etc.
            headers: {
                "Authorization": "Bearer "+localStorage.getItem('token'),
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
          }).json()
          
        if(method.localeCompare("GET") === 0){
            fetcherCache[url] = {
                data: res,
                time: getUTCTimestamp()
            };
        }
        return res;
    }
}

export function fetcher(url, method="GET", body={}, minCacheGap=10*1000) {
    if(method.localeCompare("GET") === 0 && Object.keys(fetcherCache).includes(url) && (getUTCTimestamp() - fetcherCache[url].time) < minCacheGap){
        return Promise.resolve(fetcherCache[url]);
    }
    else {
        return fetch(url, {
            method: method, //ou POST, PUT, DELETE, etc.
            headers: {
                "Authorization": "Bearer "+localStorage.getItem('token'),
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
          })
          .then(data => {
            if(method.localeCompare("GET") === 0){
                fetcherCache[url] = data;
            }
            return data;
          })
    }
}